export type StatusDefinition = {
  statusCode: string;
  status: string;
  color: string;
  borderColor: string;
  /** Lucide icon name (PascalCase or kebab-case); rendered via lucide-react/dynamic. */
  icon?: string;
  siblings?: string[];
  order?: number;
  description?: string;
  showBook?: boolean;
  actionable?: boolean;
};

export type ShipmentLike = {
  loadStatus?: string | null;
  classification?: string | null;
  bolClassification?: string | null;
  statusHistory?: Array<{
    status: string;
    updateTime?: string | Date | null;
    interactingUser?: string;
  }>;
};

export type ResolvedShipmentStatus = StatusDefinition & {
  persistedStatus: string | null;
  resolvedStatusCode: string;
};

export const FALLBACK_STATUS: StatusDefinition = {
  statusCode: "UNK",
  status: "Unknown",
  color: "#f3f3f3",
  borderColor: "#c8c6c4",
};
